import './DashboardStatus.css';
import React from 'react';
var statusColors = {
  DRAFT: {
    bg: '#F2F1ED',
    border: '#C4C4C4'
  },
  COMPLETE: {
    bg: '#C4E3F5',
    border: '#95ADBA'
  },
  REJECTED: {
    bg: '#F5C3C7',
    border: '#C19397'
  },
  ADDITIONALDOCREQUIRED: {
    bg: '#F2F1ED',
    border: '#C4C4C4'
  },
  INPROCESS: {
    bg: '#FCE5C8',
    border: '#C6B096'
  },
  APPROVED: {
    bg: '#B6EFBD',
    border: '#9EC1A3'
  },
  PAID: {},
  PAYMENTINITIATED: {},
  PAYMENTFAILED: {},
  PAYMENTREQUIRED: {}
};
var DashboardStatus = function DashboardStatus(_ref) {
  var theme = _ref.theme,
    label = _ref.label;
  return /*#__PURE__*/React.createElement("span", {
    className: "dashboard-status ".concat(commonStyles),
    "data-bg": theme
  }, label);
};
export default DashboardStatus;
var commonStyles = "cm78f8u";
// const ltrStyles = css`${}`;
// const rtlStyles = css`${}`;